module.exports = __webpack_public_path__ + "static/media/gsu_logo.98de77ec.png";